// 越南语（默认语言）
export default {
	common: {
		requestFailed: 'Yêu cầu thất bại',
		needLogin: 'Bạn cần đăng nhập',
		accountLoggedOut: 'Tài khoản đã đăng xuất',
		confirm: 'Xác nhận',
		cancel: 'Hủy',
	},
	nav: {
			home: 'Trang chủ',
			list: 'Danh sách',
			game: 'Xác minh',
			video: 'Phim',
			mine: 'Tôi',
		},

	route: {
		home: 'Trang chủ',
		choose: 'Chọn phụ nữ',
		list: 'Danh sách chọn phụ nữ',
		profile: 'Thông tin chi tiết',
		mine: 'Của tôi',
		video: 'Video',
		game: 'Trò chơi',
		login: 'Đăng nhập',
		register: 'Đăng ký',
		serviceOnline: 'Dịch vụ trực tuyến',
		servicePage: 'Dịch vụ trực tuyến',
		setting: 'Cài đặt',
		infomation: 'Thông tin cơ bản',
		setname: 'Sửa tên thật',
		setsex: 'Sửa giới tính',
		setPayPassword: 'Quản lý mật khẩu thanh toán',
		setLoginPassword: 'Quản lý mật khẩu đăng nhập',
		lottery: 'Trang chi tiết',
		notice: 'Thông báo',
		playVideo: 'Phát video',
		setbank: 'Nhập thông tin thẻ nhận tiền',
		bindCard: 'Nhập thông tin thẻ nhận tiền',
		withdraw: 'Rút tiền',
		personalreport: 'Báo cáo cá nhân',
		withdrawRecord: 'Lịch sử rút tiền',
		gameRecord: 'Lịch sử nhiệm vụ',
	},
	page: {
		login: {
			title: 'Đăng nhập',
			usernamePlaceholder: 'Nhập tên người dùng',
			passwordPlaceholder: 'Nhập mật khẩu',
			forgotPassword: 'Quên mật khẩu?',
			registerPrompt: 'Chưa có tài khoản? Đăng ký ngay',
			loginBtn: 'Đăng nhập',
			enterUsername: 'Vui lòng nhập tên người dùng!',
			enterPassword: 'Vui lòng nhập mật khẩu!',
		},
		mine: {
			recharge: 'Nạp tiền',
			withdraw: 'Rút tiền',
			myWallet: 'Ví của tôi',
			detail: 'Chi tiết',
			balance: 'Số dư',
			personalReport: 'Báo cáo cá nhân',
			accountDetail: 'Chi tiết tài khoản',
			taskRecord: 'Nhiệm vụ ghi chú',
			profileCenter: 'Trung tâm cá nhân',
			notice: 'Thông báo',
			onlineService: 'Hỗ trợ trực tuyến',
			refreshSuccess: 'Làm mới thành công',
			exitTaskWarn: 'Vui lòng hoàn thành nhiệm vụ trước khi rời khỏi',
			rechargeContactService: 'Vui lòng liên hệ dịch vụ khách hàng để nạp tiền',
			setBankCardFirst: 'Vui lòng cài đặt thông tin thẻ nhận tiền!',
			functionDisabled: 'Chức năng đã bị vô hiệu hóa!',
			guestUsername: 'Đăng nhập/Đăng ký',
			guestSubtitle: 'Đăng nhập để trải nghiệm thêm dịch vụ!',
		},
		setting: {
			navTitle: 'Cài đặt',
			basicInfoSetting: 'Cài đặt thông tin cơ bản',
			loginPassword: 'Mật khẩu đăng nhập',
			payPassword: 'Mật khẩu tài chính',
			payPasswordSet: 'Đã đặt',
			payPasswordUnset: 'Chưa đặt',
			logout: 'Đăng xuất',
			payPasswordAlreadySet: 'Mật khẩu rút tiền đã được đặt, nếu bạn muốn thay đổi, vui lòng liên hệ với dịch vụ khách hàng',
			language: 'Chuyển ngôn ngữ',
		},
		infomation: {
			navTitle: 'Thông tin cơ bản',
			avatar: 'Ảnh đại diện',
			selectAvatar: 'Chọn ảnh đại diện',
			realName: 'Họ tên thật',
			notSet: 'Chưa đặt',
			gender: 'Giới tính',
			genderUndefined: 'Chưa xác định',
			male: 'Nam',
			female: 'Nữ',
			bankBinding: 'Liên kết ngân hàng',
			linked: 'Đã liên kết',
			none: 'Không có',
		},
		setname: {
			navTitle: 'Thay đổi tên thật',
			save: 'Lưu',
			name: 'Tên',
			namePlaceholder: 'Vui lòng nhập tên thật',
			nameWarn: 'Để đảm bảo an toàn tài khoản của bạn, tên thật cần phải khớp với tên trên thẻ ngân hàng đã liên kết',
			dontSetAgain: 'Vui lòng không cài đặt lại!',
			enterName: 'Vui lòng nhập tên!',
		},
		setsex: {
			navTitle: 'Thay đổi giới tính',
			male: 'Nam',
			female: 'Nữ',
		},
		setPayPassword: {
			navTitle: 'Thiết lập mật khẩu giao dịch',
			enterPassword: 'Nhập mật khẩu giao dịch',
			confirmPassword: 'Nhập lại mật khẩu giao dịch',
			fillComplete: 'Vui lòng điền đầy đủ',
			passwordMismatch: 'Mật khẩu không khớp!',
		},
		setLoginPassword: {
			navTitle: 'Thay đổi mật khẩu đăng nhập',
			save: 'Lưu',
			oldPassword: 'Mật khẩu cũ',
			oldPasswordPlaceholder: 'Vui lòng nhập mật khẩu cũ',
			newPassword: 'Mật khẩu mới',
			newPasswordPlaceholder: 'Vui lòng nhập mật khẩu mới',
			confirmPasswordPlaceholder: 'Vui lòng nhập lại mật khẩu mới',
			fillComplete: 'Vui lòng điền đầy đủ thông tin!',
			passwordMismatch: 'Hai lần nhập mật khẩu không khớp',
		},
		notice: {
			navTitle: 'Thông báo hệ thống',
			refreshSuccess: 'Làm mới thành công',
		},
		serviceOnline: {
			navTitle: 'Dịch vụ trực tuyến',
			contact: 'Liên hệ',
			serviceHours: 'Phục vụ bạn trong suốt 7 ngày 24 giờ',
		},
		servicePage: {
			navTitle: 'Dịch vụ hỗ trợ',
		},
		withdraw: {
			navTitle: 'Trung tâm rút tiền',
			history: 'Lịch sử rút tiền',
			amount: 'Số tiền rút',
			all: 'Toàn bộ',
			limit: 'Hạn mức rút tiền',
			limitPerTransaction: '1. Giới hạn mỗi giao dịch: Tối thiểu {min}, tối đa {max} ',
			limitPerDay: '2. Số lần rút tiền: Tối đa {num} lần trong một ngày',
			transferTime: '3. Thời gian chuyển khoản: Thông thường khoảng 5 phút, nhanh nhất trong vòng 2 phút',
			balanceLabel: 'Số dư:',
			withdrawNow: 'Rút tiền ngay',
			enterCorrectAmount: 'Vui lòng nhập số tiền chính xác',
		},
		withdrawRecord: {
			navTitle: 'Lịch sử rút tiền',
			noData: 'Không có dữ liệu!',
			amount: 'Số tiền:',
			info: 'Thông tin:',
			submitTime: 'Thời gian gửi:',
			auditTime: 'Thời gian duyệt:',
			refreshSuccess: 'Làm mới thành công',
		},
		bindCard: {
			navTitle: 'Điền thông tin thẻ nhận tiền',
			label: 'Vui lòng nhập thông tin thẻ nhận tiền của bạn',
			accountNumber: 'Số tài khoản',
			accountPlaceholder: 'Vui lòng nhập số tài khoản ngân hàng',
			bank: 'Ngân hàng',
			bankPlaceholder: 'Vui lòng chọn ngân hàng',
			warn: 'Người dùng thân mến, để bảo đảm an toàn tài chính của bạn, vui lòng liên kết tên thật của bạn và đặt mật khẩu rút tiền. Nếu tên không khớp với tên tài khoản, bạn sẽ không thể rút tiền.',
			confirmBind: 'Xác nhận liên kết thẻ',
			enterCardNumber: 'Vui lòng nhập số thẻ ngân hàng!',
			selectBank: 'Vui lòng chọn ngân hàng!',
		},
		setbank: {
			navTitle: 'Thông tin thẻ',
			addCard: 'Thêm thông tin thẻ rút tiền',
			tip: 'Gợi ý: Hãy liên kết với ngân hàng thương mại lớn, nếu bạn muốn thay đổi, vui lòng liên hệ với dịch vụ trực tuyến',
			setNameFirst: 'Vui lòng thiết lập tên của bạn trước khi liên kết thẻ ngân hàng！',
			setPayPasswordFirst: 'Vui lòng thiết lập mật khẩu rút tiền trước khi liên kết thẻ ngân hàng!',
		},
		personalreport: {
			navTitle: 'Báo cáo cá nhân',
			profitTitle: 'Số tiền lời (đơn vị: đồng)',
			profitFormula: 'Công thức tính lời: Số tiền trúng - Số tiền nhiệm vụ',
			taskMoney: 'Số tiền nhiệm vụ',
			rechargeMoney: 'Số tiền nạp',
			withdrawMoney: 'Số tiền rút',
			winMoney: 'Số tiền trúng',
		},
		gameRecord: {
			navTitle: 'Lịch sử nhiệm vụ',
			noData: 'Dữ liệu trống!',
			betAmount: 'Số tiền đặt:',
			betTime: 'Thời gian đặt:',
			updateTime: 'Thời gian cập nhật:',
			refreshSuccess: 'Làm mới thành công',
			kim: 'KIM',
			moc: 'MỘC',
			thuy: 'THUỶ',
			hoa: 'HOẢ',
		},
		home: {
			recommendTask: 'Nhiệm vụ đề xuất',
			viewMore: 'Xem thêm',
			popularRanking: 'Xếp hạng phổ biến',
			hotRecommend: 'Đề xuất nóng',
			playCount: 'Chơi:',
			loadingData: 'Đang lấy dữ liệu...',
			refreshSuccess: 'Làm mới thành công',
		},
		choose: {
			navTitle: 'Bạn muốn hẹn hò?',
			city: 'Thành phố',
			cityDesc: 'Cộng đồng  uy tín hàng đầu, nơi chia sẻ thông tin các em gái uy tín nhất hiện nay cho anh em. Chúng tôi cam kết mang đến một nơi uy tín, lành mạnh và đảm bảo riêng tư cho khách hàng.',
			processAndPrice: 'Quy trình và giá',
			processDesc: 'Trang web này cung cấp các dịch vụ liên quan đến ngoại vi, đồng hành kinh doanh và cảm xúc trong cùng một thành phố. Để bảo vệ quyền riêng tư của từng người dùng, khách hàng chỉ được tham gia thông qua việc liên hệ với nhân viên tiếp đãi hoặc thành viên cấp cao của nền tảng này.',
			resourcesTitle: 'Có những nguồn tài nguyên nào?',
			resourcesContent: 'Có thể tìm thấy các nghệ sĩ nổi tiếng, người mẫu, tiếp viên hàng không, người mẫu trẻ, sinh viên đại học, không có điều gì là không thể với nền tảng này',
			serviceScopeTitle: 'Phạm vi dịch vụ?',
			serviceScopeContent1: 'Hẹn hò miễn phí trong cùng một thành phố, tất cả các địa điểm trên toàn quốc, có mặt tại các thành phố hàng đầu trong nước, cũng có thể sắp xếp thông qua việc liên hệ với nhân viên tiếp đãi.',
			serviceScopeContent2: 'Trang web này cung cấp các dịch vụ liên quan đến ngoại vi, đồng hành kinh doanh và cảm xúc trong cùng một thành phố. Để bảo vệ quyền riêng tư của từng người dùng, khách hàng chỉ được tham gia thông qua việc liên hệ với nhân viên tiếp đãi hoặc thành viên cấp cao của nền tảng này.',
		},
		list: {
			refreshSuccess: 'Làm mới thành công',
		},
		profile: {
			navTitle: 'Chọn phi',
			bookAppointment: 'Đặt lịch hẹn',
			contactConsultant: 'Vui lòng liên hệ với tư vấn viên hoặc lễ tân',
		},
		video: {
			navTitle: 'Rạp chiếu phim',
			noMore: 'Không còn nữa',
			playCount: 'Chơi:',
			refreshSuccess: 'Làm mới thành công',
		},
		playVideo: {
			playCount: 'lượt chơi',
			hotRecommend: 'Gợi ý nổi bật',
			rechargeToWatch: 'Vui lòng nạp tiền trước để xem video!',
		},
		game: {
			navTitle: 'Phòng bỏ phiếu',
			all: 'Tất cả',
			refreshSuccess: 'Làm mới thành công',
		},
		register: {
			title: 'Đăng ký',
			usernamePlaceholder: 'Nhập tên người dùng (6-12 ký tự chữ cái hoặc số)',
			passwordPlaceholder: 'Nhập mật khẩu (6-12 ký tự chữ cái hoặc số)',
			codePlaceholder: 'Nhập mã mời',
			agreementText: 'Tôi đã hiểu và đồng ý với các điều khoản của "Thỏa thuận tài khoản"',
			registerBtn: 'Đăng ký',
			enterUsername: 'Vui lòng nhập tên người dùng!',
			enterPassword: 'Vui lòng nhập mật khẩu!',
			enterCode: 'Vui lòng nhập mã mời!',
			agreeTerms: 'Vui lòng đồng ý với các điều khoản bên dưới!',
		},
		lottery: {
			taskHistory: 'Lịch sử nhiệm vụ',
			rules: 'Quy tắc chơi',
			playHint: 'Gợi ý chơi',
			playHintDetail: 'Chọn số từ dạng hình thức và giá trị có thể chọn để đặt',
			prizeGuide: 'Hướng dẫn trúng thưởng',
			prizeGuideDetail: 'Tổng giá trị của ba số trúng từ 11 đến 18 là lớn; tổng giá trị của ba số trúng từ 3 đến 10 là nhỏ;',
			betExample: 'Ví dụ đặt',
			betExampleDetail: 'Gợi ý đặt: nhỏ Kết quả xổ số: 123, tức là trúng nhỏ',
			taskOrder: 'Đơn hàng nhiệm vụ',
			availableBalance: 'Số dư khả dụng',
			currency: 'Phân số',
			submit: 'Gửi',
			currentChoice: 'Lựa chọn hiện tại:',
			betAmount: 'Số tiền đặt:',
			enterAmount: 'Nhập số tiền',
			selected: 'Đã chọn',
			total: 'Tổng',
			orderDetail: '1 x {money}đ = {money}',
			clearOrder: 'Xóa đơn hàng',
			confirmSubmit: 'Xác nhận gửi',
			periodNumber: 'Kỳ số',
			resultNumber: 'Số kết quả',
			notSelected: 'Chưa chọn',
			invalidAmount: 'Số tiền không hợp lệ!',
			selectNumber: 'Vui lòng chọn số!',
			enterAmountWarn: 'Vui lòng nhập số tiền!',
			insufficientBalance: 'Số dư không đủ, vui lòng liên hệ dịch vụ khách hàng để nạp tiền!',
			refreshSuccess: 'Làm mới thành công',
			contactAdminForTask: 'Vui lòng liên hệ quản trị viên để nhận nhiệm vụ này!',
			lotteryResultPeriod: 'Kết quả xổ số, số kỳ: {period}',
			"lotterynow": "Kỳ hiện tại",
			    "lotterying": "Đang bỏ phiếu",
			    "lottery_da": "Tên lửa",
			    "lottery_xiao": "Trái tim",
			    "lottery_dan": "Du thuyền",
			    "lottery_shuang": "Hoa hồng",
			    "lottery_piao": "Vé",
			    "lottery_his": "Lịch sử",
			    "lottery_log": "Bản ghi",
			    "lottery_sec": "Lựa chọn bỏ phiếu"
		},
		ordlan: {
			"PopularMembers": "Thành viên nổi bật",
			    "Rating": "Đánh giá",
			    "AppointmentRequest": "Yêu cầu đặt lịch",
			    "PersonalVideoVerification": "Xác minh video cá nhân",
			    "IdentityVerification": "Xác minh danh tính",
			    "ManagerProfile": "Hồ sơ quản lý",
			    "ServiceArea": "Khu vực dịch vụ",
			    "TravelAvailable": "Có thể đi phục vụ",
			    "Yes": "Có",
				help:'Giúp đỡ',
				AgencyBooking:'Agency Booking',
				More:'Thêm',
		}
	},
}
